
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1152:603)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#fff"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M37.685 19.028h-4.4v-4.4h-1.257v4.4h-4.4v1.257h4.4v4.4h1.257v-4.4h4.4v-1.257zm-12.589 3.917a6.512 6.512 0 00-4.596-1.897 6.512 6.512 0 00-4.596 1.897A6.463 6.463 0 0014 27.525c0 1.717.685 3.364 1.904 4.578A6.512 6.512 0 0020.5 34a6.512 6.512 0 004.596-1.897A6.463 6.463 0 0027 27.524a6.463 6.463 0 00-1.904-4.579zm-5.67 3.106l1.074-2.17 1.075 2.169 2.402.348-1.738 1.689.41 2.384-2.149-1.126-2.15 1.126.411-2.384-1.738-1.688 2.402-.348zM25.374 17L21.312 17v2.469a8.097 8.097 0 012.956.881l1.107-.92V17zm-5.688 2.468V17h-4.062v2.43l1.108.92a8.094 8.094 0 012.954-.881z","fill":"#8200FF"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1152:603","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1152:603"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1152:603","result":"shape"}})])])])
          )
        }
      }
    